export function ImagesIt() {
    return require.context('./img/it', false, /\.(png|jpe?g|gif|svg)$/);
}
